/**
 * Created by vladislav on 4/2/2024
 */

const PlatformDetector = function () {
    const platforms = {
        microsoft: typeof Microsoft !== "undefined" && Microsoft,
        msix: typeof MSIX !== "undefined" && MSIX,
        g5windows: typeof G5Windows !== "undefined" && G5Windows,
        msstart: typeof MSStart !== "undefined" && MSStart,
        gdcom: typeof GDCom !== "undefined" && GDCom,
        coolmath: typeof CoolMathGames !== "undefined" && CoolMathGames,
        instant: typeof Instant !== "undefined" && Instant,
        ok: typeof OKPlatform !== "undefined" && OKPlatform,
        okbridge: typeof OKBridgePlatform !== "undefined" && OKBridgePlatform,
        mm: typeof MyMailRu !== "undefined" && MyMailRu,
        vk: typeof VKPlatform !== "undefined" && VKPlatform,
        sp_mbga: typeof SPMobage !== "undefined" && SPMobage,
        mbga: typeof Mobage !== "undefined" && Mobage,
        draugiem: typeof Draugiem !== "undefined" && Draugiem,
        fotostrana: typeof FotoStrana !== "undefined" && FotoStrana,
        cleverapps: typeof CleverApps !== "undefined" && CleverApps,
        labsystech: typeof LabSysTech !== "undefined" && LabSysTech,
        yandex: typeof Yandex !== "undefined" && Yandex,
        macos: typeof MacOS !== "undefined" && MacOS,
        ios: typeof IOS !== "undefined" && IOS,
        gpg: typeof GPG !== "undefined" && GPG,
        android: typeof AndroidPlatform !== "undefined" && AndroidPlatform,
        digital: typeof Digital !== "undefined" && Digital,
        digitalweb: typeof DigitalWeb !== "undefined" && DigitalWeb,
        plng: typeof Plinga !== "undefined" && Plinga,
        kongregate: typeof Kongregate !== "undefined" && Kongregate,
        crazy: typeof Crazy !== "undefined" && Crazy,
        rustore: typeof Rustore !== "undefined" && Rustore,
        onestore: typeof OneStore !== "undefined" && OneStore,
        amazon: typeof Amazon !== "undefined" && Amazon,
        mygames: typeof Mygames !== "undefined" && Mygames,
        samsung: typeof Samsung !== "undefined" && Samsung,
        xiaomi: typeof Xiaomi !== "undefined" && Xiaomi,
        pwa: typeof PWA !== "undefined" && PWA,
        wechat: typeof Wechat !== "undefined" && Wechat,
        youtube: typeof Youtube !== "undefined" && Youtube,
        gamesnack: typeof GameSnack !== "undefined" && GameSnack,
        discord: typeof Discord !== "undefined" && Discord,
        telegram: typeof Telegram !== "undefined" && Telegram,
        mspwa: typeof MSPwa !== "undefined" && MSPwa,
        test: typeof TestPlatform !== "undefined" && TestPlatform,
        epicgames: typeof EpicGames !== "undefined" && EpicGames,
        reddit: typeof RedditPlatform !== "undefined" && RedditPlatform,
        tiktok: typeof TikTok !== "undefined" && TikTok,
        arkadium: typeof Arkadium !== "undefined" && Arkadium,
        addicting: typeof AddictingGames !== "undefined" && AddictingGames,
        pogo: typeof Pogo !== "undefined" && Pogo
    };

    let source = connector.info.source;

    if (connector.config[source] && connector.config[source].adsense !== undefined) {
        connector.config.adsense = connector.config[source].adsense;
    }

    if (connector.config[source] && connector.config[source].xsolla !== undefined) {
        connector.config.xsolla = connector.config[source].xsolla;
    }

    if (source === "ok" && connector.config.ok && connector.config.ok.bridge) {
        source = "okbridge";
    }

    const platform = platforms[source] || platforms.cleverapps;
    if (!platform) {
        throw new Error(`No platform for source "${source}" in this build`);
    }

    return platform;
};
